export default {
    done: 'Выполнить',
};
